import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Autocomplete, TextField, Chip,
  Button, FormControl, Select, MenuItem, Dialog, DialogContent, CircularProgress, Tooltip,
  DialogTitle,
  DialogContentText,
  DialogActions, FormHelperText,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import CustomAlert from '../../commun/CustomAlert';
import AjouterTalentModal from '../../commun/AddTalentModal';
import AddIcon from '@mui/icons-material/Add';
import EuroIcon from '@mui/icons-material/Euro';
import DescriptionIcon from '@mui/icons-material/Description';
import CloseIcon from '@mui/icons-material/Close';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import './SendCandidats.css';
import PresentationModal from '../candidat/detailTalent/PresentationModal';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const UPLOADS_URL = process.env.REACT_APP_API_BASE_URL || 'https://server.cooptaleo.com';
const API_CORRECTIONS_URL = process.env.REACT_APP_API_CORRECTIONS_URL || 'https://cooptaleo.com/corrections';

function getStatutLabel(statut) {
  if (!statut) return "";
  if (statut === "Qualifie attente controle") return "Talent qualifié";
  if (statut.toLowerCase() === "a traiter" || statut.toLowerCase() === "à traiter") return "Talent à traiter";
  return statut;
}

const DEVISES = [
  { value: "EUR", label: "EUR" },
  { value: "MAD", label: "MAD" },
  { value: "TND", label: "TND" },
];


const SendCandidats = () => {
  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const preselectedTalentId = params.get('t');

  const [mission, setMission] = useState(location.state?.mission || null);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem("userId");

  const [talents, setTalents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [generatedCVs, setGeneratedCVs] = useState({});
  const [selectedCVs, setSelectedCVs] = useState({});
  const [inputDevises, setInputDevises] = useState({});
  const [inputTarifs, setInputTarifs] = useState({});
  const [tarifErrors, setTarifErrors] = useState({});
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });
  const [openModal, setOpenModal] = useState(false);
  const [envoyes, setEnvoyes] = useState([]);
  const [iaModal, setIaModal] = useState({ open: false, talent: null });
  const [autoGenLoading, setAutoGenLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [suggestedTalentIds, setSuggestedTalentIds] = useState([]);
  const [singleCandidatureId, setSingleCandidatureId] = useState(null);
  const [similarityScores, setSimilarityScores] = useState({});
  const [adminTalents, setAdminTalents] = useState([]);
  const [devise, setDevise] = useState('EUR');


  // Etat pour popup recap
  const [openRecap, setOpenRecap] = useState(false);
  const [recapTalents, setRecapTalents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!mission && id) {
      fetch(`${API_BASE}/api/missions/${id}`)
        .then(res => res.json())
        .then(setMission)
        .catch(console.error);
    }
  }, [id, mission, API_BASE]);

  useEffect(() => {
    fetch(`${API_BASE}/api/recruteur/get-talents?recruteurId=${userId}`)
      .then(res => res.json())
      .then(data => {
        const filtered = Array.isArray(data)
          ? data.filter(talent => talent.statut !== 'A traiter')
          : [];
        setTalents(filtered);
      })
      .catch(console.error);
  }, [userId, API_BASE]);
  
  
    useEffect(() => {
      fetch(`${API_BASE}/api/recruteur/admin-talents?recruteurId=${userId}`)
      .then(res => res.json())
      .then(data => setAdminTalents(Array.isArray(data) ? data : []))
      .catch(console.error);
    }, [userId, API_BASE]);

      useEffect(() => {
        if (mission?._id && userId) {
          fetch(`${API_BASE}/api/candidatures/envoyees?missionId=${mission._id}&recruteurId=${userId}`)
            .then(res => res.json())
            .then(setEnvoyes)
            .catch(console.error);
        }
      }, [mission, userId, API_BASE]);
    const mergedTalents = [
      ...(Array.isArray(adminTalents) ? adminTalents.map(t => ({ ...t, source: 'admin' })) : []),
      ...(Array.isArray(talents) ? talents.map(t => ({ ...t, source: 'recruteur' })) : [])
    ];

  useEffect(() => {
    const fetchCVs = async () => {
      const cvMap = {};
      await Promise.all(
        talents.map(async (t) => {
          const res = await fetch(`${API_BASE}/api/cv-generated/list/${t._id}`);
          const data = await res.json();
          if (data.status === 'success') {
            cvMap[t._id] = data.data;
          }
        })
      );
      setGeneratedCVs(cvMap);
    };
    if (talents.length > 0) fetchCVs();
  }, [talents, API_BASE]);

  useEffect(() => {
    mergedTalents.forEach(talent => {
      const cvs = generatedCVs[talent._id] || [];
      if (cvs.length > 0) {
        const sortedCVs = [...cvs].sort((a, b) =>
          new Date(b.generatedAt || b.date || 0) - new Date(a.generatedAt || a.date || 0)
        );
        if (!selectedCVs[talent._id]) {
          const defaultCv = sortedCVs[0];
          setSelectedCVs(prev => ({
            ...prev,
            [talent._id]: {
              id: defaultCv._id,
              name: defaultCv.name,
              type: "anonyme",
              selected: JSON.stringify({
                id: defaultCv._id,
                name: defaultCv.name,
                type: "anonyme"
              })
            }
          }));
        }        
      }
    });
    // eslint-disable-next-line
  }, [generatedCVs, talents]);

  const formatDate = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  // ------------------ Génération Automatique d'un CV Anonymisé --------------------
  const handleGenerateCVAuto = async (talent) => {
    setAutoGenLoading(true);
    setIaModal({ open: true, talent });
    try {
      // 1. Récupération du CV original
      const response = await fetch(`${API_BASE}/api/recruteur/uploads/${talent.cvUpload}`);
      if (!response.ok) throw new Error("Impossible de récupérer le CV.");
      const cvBlob = await response.blob();

      // 2. Envoi à l'API corrections pour extraction
      const formData = new FormData();
      formData.append('file', cvBlob, talent.cvUpload);
      formData.append('choice', 'option1');
      const extractionRes = await fetch(`${API_CORRECTIONS_URL}/`, {
        method: 'POST',
        body: formData,
      });
      const extractionData = await extractionRes.json();
      if (extractionData.status !== 'success') throw new Error("Erreur lors de l'extraction du CV");

      const corrections = extractionData.data;

      // 3. Sauvegarde des corrections dans la base (JSON)
      const saveRes = await fetch(`${UPLOADS_URL}/api/cv-corrections/save`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          talentId: talent._id,
          data: corrections,
          userId: localStorage.getItem('userId'),
        }),
      });
      if (!saveRes.ok) throw new Error("Erreur lors de la sauvegarde des corrections");
      
      // 4. Génération du PDF anonymisé via API Flask
      const genRes = await fetch(`${API_CORRECTIONS_URL}/user-corrections`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...corrections, choice: 'option1' }),
      });
      if (!genRes.ok) throw new Error("Erreur lors de la génération du PDF");

      const pdfBlob = await genRes.blob();

      // 5. Upload du fichier PDF dans la base
      const formDataPDF = new FormData();
      formDataPDF.append('file', pdfBlob, 'cv_anonymise.pdf');
      formDataPDF.append('model', 'option1');
      formDataPDF.append('talentId', talent._id);
      formDataPDF.append('name', corrections.name || '');
      formDataPDF.append('title', corrections.title || '');
      formDataPDF.append('userId', localStorage.getItem('userId'));
      formDataPDF.append('recruteurName', localStorage.getItem('recruteurName'));

      const uploadRes = await fetch(`${UPLOADS_URL}/api/cv-generated/save`, {
        method: 'POST',
        body: formDataPDF,
      });
      if (!uploadRes.ok) throw new Error("Erreur lors de l'upload du CV généré");

      // 6. Mettre à jour l'historique (fetch cv-generated pour ce talent)
      const reload = await fetch(`${API_BASE}/api/cv-generated/list/${talent._id}`);
      const newCVs = await reload.json();
      setGeneratedCVs(prev => ({ ...prev, [talent._id]: newCVs.data }));

      // 7. Sélectionner automatiquement le dernier CV généré
      const sortedCVs = [...newCVs.data].sort((a, b) =>
        new Date(b.generatedAt || b.date || 0) - new Date(a.generatedAt || a.date || 0)
      );
      const latestCvId = sortedCVs[0]?._id;
      setSelectedCVs(prev => ({ ...prev, [talent._id]: latestCvId }));

      setAlert({
        open: true,
        message: "CV anonymisé généré et enregistré avec succès.",
        severity: "success"
      });
    } catch (err) {
      setAlert({ open: true, message: err.message, severity: "error" });
    } finally {
      setIaModal({ open: false, talent: null });
      setAutoGenLoading(false);
    }
  };

  const checkIfCvExists = (talentId) => {
    const cvSelection = selectedCVs[talentId]?.selected || selectedCVs[talentId];
    if (!cvSelection) return false;
  
    let parsed;
    try { parsed = JSON.parse(cvSelection); } catch (e) { parsed = null; }
    if (!parsed) return false;
    
    const { id: ref, type } = parsed;
      
    if (type === "real") {
      return !!ref; 
    }
  
    if (type === "anonyme") {
      const cvList = generatedCVs[talentId] || [];
      return cvList.some(cv => cv._id === ref);
    }
  
    return false;
  };
  
  // Récapitulatif popup
  const handleOpenRecap = () => {
    const newTarifErrors = {};
    let hasTarifError = false;
    let hasCVError = false;
  
    selected.forEach(talentId => {
      (mission.contrats || []).forEach(contract => {
        const value = inputTarifs[talentId]?.[contract.type];
        const min = contract.tarifMin ?? 0;
        const max = contract.tarifMax ?? Infinity;
  
        if (!value || isNaN(Number(value)) || Number(value) <= 0) {
          hasTarifError = true;
          newTarifErrors[talentId] = {
            ...newTarifErrors[talentId],
            [contract.type]: "Veuillez renseigner un tarif valide",
          };
        } else if (Number(value) < min || Number(value) > max) {
          hasTarifError = true;
          newTarifErrors[talentId] = {
            ...newTarifErrors[talentId],
            [contract.type]: `Le tarif doit être entre ${min} et ${max}`,
          };
        }
      });
  
      if (!checkIfCvExists(talentId)) {
        hasCVError = true;
      }
    });
  
    setTarifErrors(newTarifErrors);
  
    if (hasTarifError) {
      setAlert({
        open: true,
        message: "Veuillez renseigner un tarif valide pour chaque talent.",
        severity: "warning",
      });
      return;
    }
  
    if (hasCVError) {
      setAlert({
        open: true,
        message: "Chaque talent doit avoir un CV sélectionné (réel ou anonymisé).",
        severity: "warning",
      });
      return;
    }
  
    // ✅ Si tout est bon
    const recap = mergedTalents.filter(t => selected.includes(t._id));
    setRecapTalents(recap);
    setOpenRecap(true);
  };
  
   

  const handleConfirmRecapAndSend = async () => {
    setOpenRecap(false);
    await handleSubmit();
    if (mission?._id && userId) {
      const resEnvoyes = await fetch(`${API_BASE}/api/candidatures/envoyees?missionId=${mission._id}&recruteurId=${userId}`);
      const envoyesData = await resEnvoyes.json();
      setEnvoyes(envoyesData);
      setSelected(sel => sel.filter(id => !envoyesData.includes(id)));
    }
  };


useEffect(() => {
  if (mission?._id) {
fetch(`${API_BASE}/api/matching/suggestions/${mission._id}`)
      .then(res => res.json())
      .then(data => {
        const ids = Array.isArray(data) ? data.map(t => t._id) : [];
        setSuggestedTalentIds(ids);
      })
      .catch(console.error);
  }
}, [mission, API_BASE]);

useEffect(() => {
  const fetchSimilarityScores = async () => {
    if (!mission?._id) return;

    const allTalents = [...talents, ...adminTalents];
    if (allTalents.length === 0) return;

    const scores = {};
    await Promise.all(allTalents.map(async (talent) => {
      try {
        const res = await fetch(`${API_BASE}/api/matching/similarity/${mission._id}/${talent._id}`);
        const data = await res.json();
        if (typeof data.similarity === 'number') {
          scores[talent._id] = data.similarity*100;
        }
      } catch (e) {
        console.error(`Erreur de similarité pour ${talent._id}`, e);
        scores[talent._id] = null;
      }
    }));
    setSimilarityScores(scores);
  };

  fetchSimilarityScores();
}, [mission, talents, adminTalents, API_BASE]);


    const handleSubmit = async () => {
      let hasTarifError = false;
      let hasDeviseError = false;
      const newErrors = {};
      const missingDeviseIds = [];

      const contratsMission = mission?.contrats || [];

      selected.forEach(id => {
        const tarifsTalent = inputTarifs[id] || {};
        const erreursTalent = {};
        contratsMission.forEach(contract => {
          const value = tarifsTalent[contract.type];

          if (!value || isNaN(Number(value)) || Number(value) <= 0) {
            erreursTalent[contract.type] = `Veuillez renseigner un tarif pour ${contract.type}`;
            hasTarifError = true;
          }
        });

        if (Object.keys(erreursTalent).length > 0) {
          newErrors[id] = erreursTalent;
        }

        const deviseTalent = inputDevises[id];
        if (!deviseTalent || deviseTalent.trim() === "") {
          missingDeviseIds.push(id);
          hasDeviseError = true;
        }
      });

      setTarifErrors(newErrors);

      if (hasTarifError) {
        setAlert({
          open: true,
          message: "⚠️ Veuillez renseigner un tarif pour chaque type de contrat de la mission.",
          severity: "warning",
        });
        return;
      }

      if (hasDeviseError) {
        setAlert({
          open: true,
          message: "⚠️ Veuillez sélectionner une devise pour chaque talent.",
          severity: "warning",
        });
        return;
      }

      if (!mission || selected.length === 0) {
        setAlert({
          open: true,
          message: "⚠️ Sélectionnez au moins un candidat.",
          severity: "warning",
        });
        return;
      }

      const candidatsSansCV = selected.filter(id =>
        !selectedCVs[id] || !selectedCVs[id].selected
      );

      if (candidatsSansCV.length > 0) {
        setAlert({
          open: true,
          message: "⚠️ Tous les talents doivent avoir un CV sélectionné pour envoyer leur candidature.",
          severity: "warning",
        });
        return;
      }

      const payload = {
        missionId: mission._id,
        entrepriseId: mission.entrepriseId || mission.entreprise,
        missionName: mission.titre || mission.nomMission || "Mission sans nom",
        recruteurId: userId,
        candidats: selected.map(id => ({
          _id: id,
          tarifs: inputTarifs[id],             
          devise: inputDevises[id],          
          cvId: selectedCVs[id]?.id || null,
          cvType: selectedCVs[id]?.type || null,
        })),
      };

      try {
        const res = await fetch(`${API_BASE}/api/candidatures/envoyer-candidats`, {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Erreur inconnue.");

        if (data.candidaturesTraitees?.length === 1) {
          setSingleCandidatureId(data.candidaturesTraitees[0]);
        } else {
          setSingleCandidatureId(null);
        }

        setModalOpen(true);
        setSuccessMsg("Une fois la candidature envoyée, vous ne pourrez plus la modifier.");
        setInputDevises({});
        setInputTarifs({});
        setSelectedCVs({});
        setTarifErrors({});

      } catch (err) {
        console.error("❌ Erreur API :", err);
        setAlert({
          open: true,
          message: err.message || "Erreur lors de l'envoi.",
          severity: "error",
        });
      }
    };



    useEffect(() => {
      if (preselectedTalentId && mergedTalents.length > 0) {
        const exists = mergedTalents.some(t => t._id === preselectedTalentId);
        if (exists && !envoyes.includes(preselectedTalentId)) {
          setSelected(prev => {
            if (!prev.includes(preselectedTalentId)) {
              return [...prev, preselectedTalentId];
            }
            return prev;
          });
        }
      }
    }, [envoyes]);

    const [tempValue, setTempValue] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");

    const handleSelectChange = (e, talentId, sortedCVs) => {
      const valueString = e.target.value;
      const parsedValue = JSON.parse(valueString);
      const type = parsedValue.type;
    
      if (type === "real") {
        setConfirmMessage(
          "Vous êtes sur le point d’envoyer un CV non anonymisé. Les données personnelles du candidat seront visibles par l’entreprise."
        );
      } else {
        setConfirmMessage(
          "Cette fonctionnalité  masque les données personnelles du candidat avant envoi à l’entreprise. Elle garantit une évaluation objective et protège le réseau du recruteur et en évitant toute prise de contact directe avant validation."
        );
      }
    
      setTempValue({ talentId, value: valueString, parsedValue, sortedCVs });
      setOpenConfirm(true);
    };    

    const handleConfirm = () => {
      const { talentId, value, parsedValue, sortedCVs } = tempValue;
      const { id: ref, type, name } = parsedValue;
    
      setSelectedCVs(prev => ({
        ...prev,
        [talentId]: {
          id: ref,
          type: type,
          selected: value, 
        },
      }));
    
      let url = "";
    
      if (type === "real") {
        const base = UPLOADS_URL ? UPLOADS_URL.replace(/\/$/, "") : "";
        url = `${base}/uploads/cv/${ref}`;
      } else {
        const cv = sortedCVs.find(c => c._id === ref);
        if (cv) {
          if (cv.fileUrl && cv.fileUrl.startsWith("http")) {
            url = cv.fileUrl;
          } else {
            const base = UPLOADS_URL ? UPLOADS_URL.replace(/\/$/, "") : "";
            url = `${base}/${cv.fileUrl || cv.name || ""}`;
          }
        }
      }
    
      setOpenConfirm(false);
      setTempValue(null);
    };
    

    const cancelConfirm = () => {
      setOpenConfirm(false);
      setTempValue(null);
    };

    return (
    <div className="sendcandidats-wrapper">
      <Box className="sendcandidats-header" mb={3}>
        <Typography variant="h6"><strong>Sélectionner un de mes talents</strong></Typography>
        <Box mt={2}>
          <Autocomplete
            fullWidth
            options={Array.isArray(mergedTalents) ? mergedTalents : []}
            getOptionLabel={(option) => `${option.prenomCandidat || ''} ${option.nomCandidat || ''}`.trim()}
            renderOption={(props, option) => {
              const isSent = envoyes.includes(option._id);
              const isRecrute = option.statut?.toLowerCase() === 'recruté';
              const isDisabled = isSent || isRecrute;

              const statutChip = (
                <Chip
                  label={isSent ? 'Talent déjà envoyé' : isRecrute ? 'Recruté' : getStatutLabel(option.statut)}
                  size="small"
                  color={isDisabled ? 'default' : 'success'}
                  style={{ marginLeft: 6 }}
                />
              );

              const isSuggested = suggestedTalentIds.includes(option._id); 
              const adminStyle = option.source === 'admin' ? { backgroundColor: '#f3f5d8' } : {};

              return (
                <li {...props} className={`autocomplete-option ${isDisabled ? 'grayed' : ''}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...adminStyle }}>
                  <span style={{ fontWeight: 500 }}>
                    {option.prenomCandidat} {option.nomCandidat}
                  </span>
                  <Box display="flex" gap={1}>
                    {isSuggested && (
                      <Chip
                        label="Suggestion IA"
                        size="small"
                        color="secondary"
                        style={{ fontWeight: 500 }}
                      />
                    )}
                    {similarityScores[option._id] !== undefined && similarityScores[option._id] < 25 && (
                      <Chip
                        label={`Matching faible`}
                        size="small"
                        color="error"
                        style={{ fontWeight: 500 }}
                      />
                    )}
                    {similarityScores[option._id] !== undefined && similarityScores[option._id] >= 25 && similarityScores[option._id] < 60  && (
                      <Chip
                        label={`Matching moyen`}
                        size="small"
                        color="warning"
                        style={{ fontWeight: 500 }}
                      />
                    )}
                    {statutChip}
                  </Box>
                </li>
              );
            }}

            onChange={(e, value) => {
              if (!value) return;
              const isSent = envoyes.includes(value?._id);
              const isRecrute = value?.statut?.toLowerCase() === 'recruté';
              if (value && !selected.includes(value._id) && !isSent && !isRecrute) {
                setSelected(prev => [...prev, value._id]);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} placeholder="Indiquez le nom du candidat à sélectionner" />
            )}
          />

          {selected.length > 0 && (
            <Box className="selected-talents-list-bottom">
              {selected.map((id) => {
                const talent = mergedTalents.find(t => t._id === id);
                if (!talent) return null;
                return (
                  <Chip
                    key={id}
                    label={`${talent.prenomCandidat || ''} ${talent.nomCandidat || ''}`}
                    onDelete={() => setSelected(prev => prev.filter(sid => sid !== id))}
                    className="selected-talent-chip"
                  />
                );
              })}
            </Box>
          )}
        </Box>
      </Box>

      <Box className="sendcandidats-content">
        <Box mt={3} display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Typography variant="body2" color="textSecondary">ou</Typography>
          <Button variant="outlined" onClick={() => setOpenModal(true)} startIcon={<AddIcon />}>
            Ajouter un nouveau candidat
          </Button>
        </Box>

        <Box mt={4} className="cartes-candidats-list">
          {mergedTalents.filter(t => selected.includes(t._id)).map(talent => {
            const cvs = generatedCVs[talent._id] || [];
            const sortedCVs = [...cvs]
              .sort((a, b) => new Date(b.generatedAt || b.date || 0) - new Date(a.generatedAt || a.date || 0))
              .filter((cv, index, self) =>
                index === self.findIndex(other =>
                  (other.name === cv.name) && (other.fileUrl === cv.fileUrl)
                )
              );

              const hasAnonymisedCV = sortedCVs.length > 0;

            return (
              <Box className={`talent-card ${selected.includes(talent._id) ? "card-selected" : ""}`} key={talent._id}>
                <Box className="card-header">
                  <Typography className="talent-card-name">
                    <a
                      href={`/Recruteur/talent-detail/${talent._id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nom-prenom-link"
                      style={{ textDecoration: 'none', color: '#185bb6', fontWeight: 500 }}
                    >
                      {talent.prenomCandidat} {talent.nomCandidat}
                    </a>
                  </Typography>

                  {/* Badges matching */}
                  <Box display="flex" alignItems="center" gap={1}>
                    {suggestedTalentIds.includes(talent._id) && (
                      <Chip label="Suggestion IA" color="secondary" size="small" style={{ fontWeight: 500 }} />
                    )}
                    {similarityScores[talent._id] !== undefined && similarityScores[talent._id] < 25 && (
                      <Chip label="Matching faible" color="error" size="small" style={{ fontWeight: 500 }} />
                    )}
                    {similarityScores[talent._id] !== undefined && similarityScores[talent._id] >= 25 && similarityScores[talent._id] < 65 && (
                      <Chip label="Matching moyen" color="warning" size="small" style={{ fontWeight: 500 }} />
                    )}
                    <Chip
                      label={getStatutLabel(talent.statut)}
                      color="success"
                      size="small"
                      style={{ fontWeight: 500 }}
                    />
                  </Box>
                </Box>

                {/* ❌ Retirer le talent */}
                <Box
                  className="card-remove-btn"
                  onClick={() => setSelected(prev => prev.filter(sid => sid !== talent._id))}
                  title="Retirer ce talent"
                >
                  <CloseIcon fontSize="small" />
                </Box>

                <Box className="card-fields">
                  {/* 💰 Tarifs */}
                  <Box className="card-fields" display="flex" flexDirection="column" gap={2}>
                    {mission.contrats?.map(contract => {
                      const isCDI = contract.type === "CDI";
                      const labelText = isCDI ? "Salaire annuel brut" : `Tarif ${contract.type}`;
                      const placeholderText = isCDI
                        ? "Ex : 50000 €"
                        : `Min: ${contract.tarifMin ?? "-"}, Max: ${contract.tarifMax ?? "-"}`;

                      const min = contract.tarifMin ?? 0;
                      const max = contract.tarifMax ?? Infinity;
                      const currentValue = inputTarifs[talent._id]?.[contract.type] ?? "";
                      const hasError = tarifErrors[talent._id]?.[contract.type];

                      return (
                        <Box key={contract.type} className="field-col" display="flex" gap={2}>
                          <FormControl
                            required
                            error={!!hasError}
                            size="small"
                            fullWidth
                            variant="outlined"
                          >
                            <InputLabel htmlFor={`tarif-${talent._id}-${contract.type}`}>
                              {labelText}
                            </InputLabel>
                            <OutlinedInput
                              id={`tarif-${talent._id}-${contract.type}`}
                              type="number"
                              value={currentValue}
                              onChange={e => {
                                const value = e.target.value;
                                setInputTarifs(prev => ({
                                  ...prev,
                                  [talent._id]: {
                                    ...prev[talent._id],
                                    [contract.type]: value,
                                  },
                                }));

                                if (value && (Number(value) < min || Number(value) > max)) {
                                  setTarifErrors(prev => ({
                                    ...prev,
                                    [talent._id]: {
                                      ...prev[talent._id],
                                      [contract.type]: `La valeur doit être comprise entre ${min} et ${max}`,
                                    },
                                  }));
                                } else {
                                  setTarifErrors(prev => {
                                    const updated = { ...(prev[talent._id] || {}) };
                                    delete updated[contract.type];
                                    return {
                                      ...prev,
                                      [talent._id]: updated,
                                    };
                                  });
                                }
                              }}
                              endAdornment={
                                <InputAdornment position="end">
                                  <FormControl variant="standard" sx={{ minWidth: 60 }}>
                                    <Select
                                      value={inputDevises[talent._id] || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        setInputDevises(prev => ({
                                          ...prev,
                                          [talent._id]: value
                                        }));
                                      }}
                                      disableUnderline
                                    >
                                      <MenuItem value="EUR">EUR</MenuItem>
                                      <MenuItem value="MAD">MAD</MenuItem>
                                      <MenuItem value="TND">TND</MenuItem>
                                      <MenuItem value="EGP">EGP</MenuItem>
                                    </Select>
                                  </FormControl>
                                </InputAdornment>
                              }
                              placeholder={placeholderText}
                              label={labelText}
                            />
                            {hasError && <FormHelperText>{hasError}</FormHelperText>}
                          </FormControl>
                        </Box>
                      );
                    })}
                  </Box>

                  {/* 📄 Section CV */}
                  <Box className="field-col" style={{ flex: 1 }}>
                    <label className="input-label">CV</label>

                    {/* 📌 Aucun CV uploadé du tout */}
                    {(!talent.cvUpload && sortedCVs.length === 0) ? (
                      <Box className="no-cv-box">
                        <span>Aucun CV disponible pour ce talent.</span>
                        <Button
                          variant="outlined"
                          size="small"
                          style={{ marginTop: 6, maxWidth: 230 }}
                          disabled={autoGenLoading}
                          onClick={() => handleGenerateCVAuto(talent)}
                        >
                          Anonymiser maintenant
                        </Button>
                      </Box>
                    ) : (
                      <>
                        <FormControl size="small" className="card-cv" fullWidth>
                          <Select
                            value={selectedCVs[talent._id]?.selected ?? ""}
                            onChange={(e) => handleSelectChange(e, talent._id, sortedCVs)}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) return "Sélectionner un CV";
                              const parsed = JSON.parse(selected);
                              return parsed.name || "Sélectionner un CV";
                            }}
                          >
                            <MenuItem disabled value="">
                              <em>Sélectionner un CV</em>
                            </MenuItem>

                            {/* CV Réel */}
                            {talent.cvUpload && (
                              <MenuItem
                                key="cv-reel"
                                value={JSON.stringify({
                                  id: talent.cvUpload,
                                  name: "CV Réel",
                                  type: "real"
                                })}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                  <DescriptionIcon fontSize="small" style={{ color: "#2e7d32", marginRight: 6 }} />
                                  <span style={{ fontWeight: 500 }}>CV Réel</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                                  <a
                                    href={`${API_BASE}/uploads/cv/${talent.cvUpload}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: "#1976d2",
                                      display: "flex",
                                      alignItems: "center",
                                      textDecoration: "none",
                                    }}
                                    onClick={e => e.stopPropagation()}
                                    title="Voir le CV réel"
                                  >
                                    <VisibilityOutlinedIcon style={{ fontSize: 22 }} />
                                  </a>
                                  {talent.updatedAt && (
                                    <small style={{ color: "#666", minWidth: 120 }}>
                                      Uploadé le {formatDate(talent.updatedAt)}
                                    </small>
                                  )}
                                </div>
                              </MenuItem>
                            )}

                            {/* CV anonymisés */}
                            {sortedCVs.map(cv => {
                              const baseUrl = UPLOADS_URL ? UPLOADS_URL.replace(/\/$/, "") : "";
                              const fileUrl = cv.fileUrl && cv.fileUrl.startsWith("http")
                                ? cv.fileUrl
                                : `${baseUrl}/${cv.fileUrl || cv.name || ""}`;

                              return (
                                <MenuItem
                                  key={cv._id}
                                  value={JSON.stringify({
                                    id: cv._id,
                                    name: cv.name,
                                    type: "anonyme"
                                  })}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <DescriptionIcon fontSize="small" style={{ color: "#1976d2", marginRight: 6 }} />
                                    <span style={{ fontWeight: 500 }}>{cv.name}</span>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                                    <a
                                      href={fileUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "#1976d2",
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                      }}
                                      onClick={e => e.stopPropagation()}
                                      title="Voir le CV anonymisé"
                                    >
                                      <VisibilityOutlinedIcon style={{ fontSize: 22 }} />
                                    </a>
                                    <small style={{ color: "#666", minWidth: 120 }}>
                                      Généré le {formatDate(cv.generatedAt)}
                                    </small>
                                  </div>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>

                        {/* 🪄 Bouton Anonymiser si aucun CV anonymisé n'existe */}
                        {talent.cvUpload && !hasAnonymisedCV && (
                          <Button
                            variant="outlined"
                            size="small"
                            style={{ marginTop: 8 }}
                            disabled={autoGenLoading}
                            onClick={() => handleGenerateCVAuto(talent)}
                          >
                            Anonymiser maintenant
                          </Button>
                        )}

                        <Dialog open={openConfirm} onClose={cancelConfirm}>
                          <DialogTitle>Confirmer l'envoi du CV</DialogTitle>
                          <DialogContent>
                            <DialogContentText>{confirmMessage}</DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={cancelConfirm}>Retour</Button>
                            <Button onClick={handleConfirm} color="primary" variant="contained">
                              Confirmer
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            );
          })}
        </Box>


        <Box mt={3} textAlign="center">
          <Button onClick={handleOpenRecap} variant="contained">
            Envoyer la candidature
          </Button>
        </Box>
      </Box>

      <CustomAlert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={() => setAlert(prev => ({ ...prev, open: false }))}
      />

      <AjouterTalentModal open={openModal} onClose={() => setOpenModal(false)} />

      <Dialog
        open={iaModal.open}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { borderRadius: 15, textAlign: 'center', padding: 18 } }}
      >
        <DialogContent style={{ background: "#f7fbff" }}>
          <SmartToyIcon style={{ fontSize: 38, color: "#1976d2" }} />
          <Typography variant="h6" style={{ margin: "18px 0 7px" }}>
            Génération du profil anonymisé...
          </Typography>
          <CircularProgress style={{ margin: "15px 0" }} />
          <Typography variant="body2" style={{ marginTop: 10 }}>
            Merci de rester connecté(e) le temps que l'IA génère le profil anonymisé du talent.
          </Typography>
        </DialogContent>
      </Dialog>

    <Dialog
      open={openRecap}
      onClose={() => setOpenRecap(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: 'recap-dialog-paper' }}
    >
        <DialogContent>
          <Typography variant="h6" className="recap-title">
            🎯 Récapitulatif de votre envoi
          </Typography>

          {recapTalents.map(talent => {
            const selectedValue = selectedCVs[talent._id]?.selected || selectedCVs[talent._id];
            let selectedCv = null;
            let cvLink = "";
            let cvLabel = "";

            if (selectedValue) {
              let parsed;
              try { parsed = JSON.parse(selectedValue); } catch (e) { parsed = null; }
              if (!parsed) return null;
              
              const { id: ref, type, name } = parsed;
              
              if (type === "real") {
                selectedCv = { name: "CV Réel" };
                cvLink = `${UPLOADS_URL.replace(/\/$/, "")}/uploads/cv/${ref}`;
                cvLabel = "CV réel";
              } else if (type === "anonyme") {
                selectedCv = (generatedCVs[talent._id] || []).find(cv => cv._id === ref);
                if (selectedCv) {
                  cvLink = selectedCv?.fileUrl?.startsWith("http")
                    ? selectedCv.fileUrl
                    : `${UPLOADS_URL}${selectedCv.fileUrl || selectedCv.name || ""}`;
                  cvLabel = "CV anonymisé";
                }
              }
            }

            const hasLowMatching = recapTalents.some(
              t => similarityScores[t._id] !== undefined && similarityScores[t._id] < 25
            );
            return (
              <Box key={talent._id} className="recap-card">
                <Typography variant="subtitle1" className="recap-name">
                  👤 {talent.prenomCandidat} {talent.nomCandidat}
                </Typography>
                
                <Box className="recap-row">
                  <EuroIcon fontSize="small" className="recap-icon" />
                  <Typography variant="body2">
                    <strong>Tarif :</strong>
                  </Typography>
                </Box>

                  <List dense>
                    {Object.entries(inputTarifs[talent._id] || {}).map(([type, value]) => (
                      <ListItem key={type}>
                        <ListItemText primary={`${type} : ${value} ${inputDevises[talent._id] || ""}`} />
                      </ListItem>
                    ))}
                  </List>

                <Box className="recap-row">
              <DescriptionIcon fontSize="small" className="recap-icon" />
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">
                  <strong>{cvLabel ? `${cvLabel}` : "CV :"}</strong>
                </Typography>
              </Box>
            </Box>
            
                {hasLowMatching && (
                  <Typography variant="body2" className="recap-warning" style={{ color: "#cc2d2d", marginTop: 12 }}>
                    ⚠️ Attention : au moins un talent présente un matching faible avec cette mission (&lt; 25%). 
                    Vous pouvez continuer l’envoi, mais la pertinence peut être limitée.
                  </Typography>
                )}
              </Box>
            );
          })}
          <Typography variant="body2" className="recap-warning">
            ⚠️ la candidature ne pourra plus être modifiée Une fois envoyée.
          </Typography>
          <Box className="recap-actions">
            <Button variant="contained" color="primary" onClick={handleConfirmRecapAndSend}>
              ✅ Confirmer l’envoi
            </Button>
            <Button variant="outlined" onClick={() => setOpenRecap(false)}>
              Annuler
            </Button>
          </Box>
        </DialogContent>
      </Dialog>


     <Dialog
        open={modalOpen}
        fullWidth
        maxWidth="sm"
        PaperProps={{ style: { textAlign: 'center', padding: '20px', borderRadius: '15px' } }}
      >
        <DialogTitle>
            <Typography variant="h5" gutterBottom color="primary">
              <CheckCircleOutlineIcon fontSize="large" style={{ verticalAlign: 'middle', marginRight: 8 }} />
                Candidature ajouté avec succès !
            </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
              <Typography variant="subtitle1">
            Vous avez la possibilité de consulter les informations de la candidature. <p></p>
              </Typography>
          </DialogContentText>
        </DialogContent>
          <DialogActions >

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (singleCandidatureId) {
                  navigate(`/Recruteur/DetailsCandidature/${singleCandidatureId._id}`);
                } else {
                  navigate(`/recruteur/candidature`);
                }
              }}
            >
              Voir le détail
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setModalOpen(false); 
                setInputDevises({});
                setInputTarifs({});
                setSelectedCVs({});
                setTarifErrors({});
                setSelected([]); 
                setSuccessMsg('');
                setSingleCandidatureId(null);
              }}
            >
              Rester sur la page
            </Button> 
         </DialogActions>
      </Dialog>
    </div>
  );
};

export default SendCandidats;
